module.exports = __webpack_public_path__ + "static/img/4.d11f2d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/4.png
// module id = Rf7D
// module chunks = 0